import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
// 非遗定制弹窗  数据对接非遗项目
import { handleHttp, loadScript, locationHandle, setImgsize } from "@/utils/utils";
import QRCode from 'qrcodejs2';
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
export default {
  data() {
    return {
      person: [],
      timer: null,
      linkcontainerflag: false,
      iframeurl: '',
      routeflag: false,
      popLeftIndex: 0,
      popLeftArr: [{
        name: '简介',
        id: 0,
        flag: true
      }, {
        name: '传承人',
        id: 1,
        flag: false
      }, {
        name: '图片',
        id: 2,
        flag: false
      }, {
        name: '视频',
        id: 3,
        flag: false
      }, {
        name: '传习所',
        id: 4,
        flag: false
      }],
      picture: [],
      videoList: [],
      videoitem: {},
      playiconshow: true,
      ewmflag: false,
      seminarList: []
    };
  },
  components: {},
  watch: {
    '$attrs.detail'(val) {
      if (val) {
        console.log(val);
      }
    },
    '$attrs.detail.person': {
      handler(val) {
        if (val) {
          this.person = [];
          this.person = val;
          this.popLeftArr[1].flag = true;
        }
      },
      deep: true
    },
    '$attrs.detail.pictureList': {
      handler(val) {
        console.log(`this.picture`);
        console.log(val);
        if (val) {
          this.picture = [];
          if (this.$route.query.fid === '138053') {
            val[0].itemformdata.img1.forEach(elem => {
              this.picture.push(elem.fileUrl);
            });
          } else {
            val[0].itemformdata[1].forEach(elem => {
              if (elem.values && elem.values[0]) this.picture.push(elem.values[0][0].fileUrl);
            });
          }
          this.popLeftArr[2].flag = true;
          this.$nextTick(() => {
            let swipersmallEl = new Swiper(this.$refs.smallswiper, {
              initialSlide: 0,
              spaceBetween: 18,
              slidesPerView: 8,
              watchSlidesProgress: true,
              observeParents: true,
              observer: true
            });
            let swiperbigEl = new Swiper(this.$refs.bigswiper, {
              initialSlide: 0,
              // autoplay: true,
              observeSlideChildren: true,
              observeParents: true,
              observer: true,
              thumbs: {
                swiper: swipersmallEl
              }
            });
          });
        }
      },
      deep: true
    },
    '$attrs.detail.videoList': {
      handler(val) {
        console.log(`this.videoList`);
        console.log(val);
        if (val) {
          this.popLeftArr[3].flag = true;
          this.videoList = [];
          if (this.$route.query.fid === '138053') {
            this.videoList = val[0].itemformdata.video;
            this.$api.getUrlByObjectId(val[0].itemformdata.video[0].objectId).then(res => {
              this.videoitem.url = res.http;
            });
          } else {
            this.videoList = val[0].itemformdata[5];
            this.$api.getUrlByObjectId(val[0].itemformdata[5][0].objectId).then(res => {
              this.videoitem.url = res.http;
            });
          }
          let elevideo = document.getElementById('video');
          elevideo.addEventListener('pause', () => {
            this.playiconshow = true;
          });
          elevideo.addEventListener('ended', () => {
            this.playiconshow = true;
          });
          this.$nextTick(() => {
            new Swiper(this.$refs.videosmallswiper, {
              initialSlide: 0,
              spaceBetween: 18,
              slidesPerView: 8,
              watchSlidesProgress: true,
              observeParents: true,
              observer: true
            });
          });
        }
      },
      deep: true
    },
    '$attrs.detail.seminarList': {
      handler(val) {
        console.log(`this.seminarList`);
        console.log(val);
        if (val) {
          this.seminarList = [];
          this.seminarList = val;
          this.popLeftArr[4].flag = true;
        }
      },
      deep: true
    }
  },
  created() {
    loadScript('https://noteyd.chaoxing.com/res/plugin/ueditor4thirdparty/multieditor.js');
  },
  mounted() {},
  methods: {
    // 关闭事件
    closePop() {
      this.$emit('closeHandle');
      this.popLeftArr.forEach((elem, index) => {
        if (index > 0) elem.flag = false;
      });
      this.popLeftIndex = 0;
      this.picture = [];
    },
    // 返回事件
    goback() {
      this.linkcontainerflag = false;
      this.iframeurl = '';
    },
    getImg(val) {
      return setImgsize(val, 160, 228);
    },
    popLeftHandle(id) {
      this.popLeftIndex = id;
    },
    openUrl(url) {
      window.open(url);
    },
    changevideo() {
      this.$refs.videoDom.play();
      this.playiconshow = false;
    },
    goLocation() {
      let details = {
        placeName: this.$attrs.detail.correlation_address[0].address,
        linkTarget: '否',
        open: true
      };
      locationHandle.call(this, details, {
        route: this.$attrs.detail.correlation_address
      });
      this.linkcontainerflag = false;
    },
    getCode() {
      this.ewmflag = true;
      new QRCode(this.$refs['qrcode-share'], {
        text: this.$attrs.detail.detailUrl,
        // 扫二维码后获得的信息
        width: 280,
        // 图片宽90px，左右padding各4px，边框各1px， 100-8px-2px
        height: 280,
        // 图片高90px，上下padding各4px，边框各1px， 100-8px-2px
        correctLevel: 3
      });
    }
  }
};